import { Component, HostListener, Inject } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent {
  confirmForm: FormGroup

  cancel = 'Cancel'
  confirm = 'Delete'
  showMessage = true
  showCancel = true
  reasonRequired = false

  focus = {
    reason: false,
  }

  public errorMessages = {
    reason: [{ type: 'required', message: 'A reason for taking this action is required.' }],
  }

  /* istanbul ignore next */
  @HostListener('document:keyup.enter', ['$event']) onEnterHandler(event: KeyboardEvent) {
    this.confirmSelected()
  }

  constructor(
    public form: FormBuilder,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = true

    this.confirmForm = this.form.group({
      reason: new FormControl('', [Validators.required]),
    })
  }

  /* istanbul ignore next */
  focusOn(focus) {
    this.focus[focus] = !this.focus[focus]
  }

  /* istanbul ignore next */
  fieldHasErrorMessages(form, validation, fieldName) {
    const field = form.get(fieldName)

    return Boolean(field.hasError(validation.type) && (field.dirty || field.touched))
  }

  /* istanbul ignore next */
  fieldHasError(form, fieldName) {
    const field = form.get(fieldName)

    return Boolean(field.invalid && (field.dirty || field.touched))
  }

  /* istanbul ignore next */
  cancelSelected(): void {
    this.dialogRef.close({ confirmed: false, reason: null })
  }

  /* istanbul ignore next */
  confirmSelected(): void {
    this.dialogRef.close({ confirmed: true, reason: this.confirmForm.controls.reason.value })
  }
}
